import { ClassType } from '../../../api'
import teamspecMoments, { LabelMoment } from '../../Util/teamspecMoments';
import { timeSpanToSeconds } from '../../../services/sessionModels';

const toMs = (timeSpan) => Math.round(timeSpanToSeconds(timeSpan) * 1000);

const getVideoDuration = (videos: Video[]) => {

  const sortVidsBySyncOffset = videos.slice().sort((a, b) => {
    return toMs(b.syncOffset) - toMs(a.syncOffset);
  });

  const maxOffset: number | undefined = sortVidsBySyncOffset && sortVidsBySyncOffset.length > 0 
    ? toMs(sortVidsBySyncOffset[0].syncOffset)
    : 0;

  let videoDuration: number =
    videos.length > 0
      ? timeSpanToSeconds(videos[0]?.length)
      : 0;

  videos.forEach((v: Video) => {
    const vDuration = timeSpanToSeconds(v?.length) - (maxOffset - toMs(v?.syncOffset))*0.001;
    videoDuration = Math.min(vDuration, videoDuration);
  });

  return videoDuration;
};

const getLabelTasks = (session: Session, lineup: LineupEntry[], includeBall: Boolean): LabelTaskInput[] => {

  session = {...session }

  const moments = teamspecMoments(session);
  const inputList: LabelTaskInput[] = [];

  const secondsPeriodOffset: number = timeSpanToSeconds(session?.startAndFinishOffset) || 3;
  
  // get a video to check our fps (assuming first video has same fps as rest)
  const fps: number = (session?.videos && session?.videos.length > 0 && session?.videos[0].fps) || 25;
  
  // Calculate video minimum duration
  const videos: Video[] | undefined | null = session?.videos;
  const videoDuration: number = videos ? getVideoDuration(videos) : 0;

  if (includeBall) {
    // Add label tasks for balls
    const ballStartX: number = (session?.pitch?.fieldWidth || 0) * 0.0005;
    const ballStartY: number = (session?.pitch?.fieldLength || 0) * 0.0005;

    session?.periods?.forEach((p: Period) => {
      inputList.push({
        startFrame: Math.round(Math.max(((p.startTimeInMilliseconds || 0)/1000 - secondsPeriodOffset) * fps, 0)),
        endFrame: Math.round(Math.min((p.endTimeInMilliseconds || 0)/1000 + secondsPeriodOffset, videoDuration) * fps),
        startX: ballStartX,
        startY: ballStartY,
        startZ: 0,
        classType: ClassType.Ball,
      });
    });
  }

  // Add label tasks for players
  session?.labelPositions?.forEach((lp: LabelPosition) => {
    // Skipping officials for now
    if (!lp.classType || lp.classType === ClassType.Referee) {
      return;
    }

    const lpVideoTimeMs = toMs(lp.videoTime);
    // get moment to find our starting frame
    const foundMoment = moments.find((m: LabelMoment) => lpVideoTimeMs === m.timestamp);
    // get period to calculate expected end frame
    const foundPeriod = session?.periods?.find(
      (p: Period) =>
        Math.max(0, (p.startTimeInMilliseconds || 0)/1000 - secondsPeriodOffset - 0.1) <= lpVideoTimeMs/1000 &&
        Math.min((p.endTimeInMilliseconds || 0)/1000 + secondsPeriodOffset + 0.1, videoDuration) >= lpVideoTimeMs/1000
    );

    let foundIdentity: LineupEntry | undefined = undefined;
    if (lp.classType === ClassType.HomeKeeper || lp.classType === ClassType.AwayKeeper) {
      foundIdentity = lineup.find((l: LineupEntry) => {
        return l.type === lp.classType;
      });
    }
    if (foundMoment?.isSubstitution) {
      // Get the right event
      const foundEvent = session?.events?.find((e: SessionEvent) => {
        return lpVideoTimeMs === toMs(e.timestamp);
      });

      if (foundEvent) {
        foundIdentity = lineup.find((l: LineupEntry) => {
          return foundEvent.in?.number === l.shirtNumber && l.type === lp.classType;
        });
      }
    }

    if (!foundPeriod || !foundMoment) {
     console.log('hi how are you?', foundMoment, foundPeriod, lp.videoTime);
    }

    if (foundPeriod && (foundMoment?.isFirstOfPeriod || foundMoment?.isSubstitution)) {
      console.log('found');
      inputList.push({
        startFrame: Math.round(foundMoment.timestamp/1000 * fps),
        endFrame: Math.round(Math.min((foundPeriod.endTimeInMilliseconds || 0)/1000 + secondsPeriodOffset, videoDuration) * fps),
        startX: lp.x || 0,
        startY: lp.y || 0,
        startZ: lp.z || 0,
        classType: lp.classType,
        lineupEntryId: foundIdentity?.id ?? null,
      });
    }
  });

  return inputList;
}

export default getLabelTasks